export function groupBy<T>(objs: readonly T[], fieldName: keyof T): Record<string, T[]> {
	let res = objs.reduce((acc: Record<string, T[]>, obj: T) => {
		const val_key = obj[fieldName] + ""
		if (acc[val_key]) {
			acc[val_key].push(obj)
		} else {
			acc[val_key] = [obj]
		}
		return acc
	}, {} as Record<string, T[]>)
	return res
}
